export interface WkSiteModel {
  id: string;
  guid: string;
  title: string;
  role?: string;
}
